<template>
  <div id="PanelBrand">
    <RouterLink to="/" class="panel-brand--link">
      <div class="title white--text">
        Hazel Jewellery
        <span class="font-weight-light">Panel</span>
      </div>
    </RouterLink>
    <div>
      <v-tooltip bottom color="black" >
        <template #activator="{on, attrs}">
          <v-btn v-on="on" v-bind="attrs" color="#ffffff14" class="panel-brand--web-action_btn mr-2" fab x-small :href="webUrl" target="_blank" depressed>
            <svg viewBox="0 0 24 24" width="25px" class="panel-brand--web-action_icon" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M7 12L16 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"></path>
                <path d="M13 16L17 12L13 8" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"></path>
              </g>
            </svg>
          </v-btn>
        </template>
        <span>Web Sitesine Git</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelBrand",

  setup() {
    const webUrl = process.env.VUE_APP_SITE_URL;
    console.log(process.env);
    return {
      webUrl
    };
  }
};
</script>

<style>
#PanelBrand {
  display: flex;
  align-items: center;
  margin-top: .25rem;
  line-height: normal;
}

.panel-brand--link {
  margin-right: .5rem;
}

.panel-brand--web-action_icon {
  transform: rotate(-25deg);
}
</style>